/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Account Type
 */
export type PostSubmitBankAccountDataRequestAccountType = typeof PostSubmitBankAccountDataRequestAccountType[keyof typeof PostSubmitBankAccountDataRequestAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostSubmitBankAccountDataRequestAccountType = {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
} as const;
